import { roleBadgeStyle, roleLabel } from "@/lib/roles";

export default function ConversationList({ threads, contacts, onSelect, onStart }) {
  return (
    <div data-testid="conversation-list" className="flex-1 overflow-y-auto">
      {threads.length === 0 && (
        <p className="px-4 py-6 text-sm text-slate-500">
          No conversations yet. Pick someone below to start one.
        </p>
      )}

      <ul>
        {threads.map((thread) => (
          <li key={thread.id}>
            <button
              data-testid={`conversation-${thread.id}`}
              onClick={() => onSelect(thread)}
              className="w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-slate-50 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-600"
            >
              <div className="w-9 h-9 shrink-0 rounded-full bg-slate-900 text-white flex items-center justify-center text-sm font-semibold">
                {thread.other?.name?.[0]?.toUpperCase() || "?"}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-slate-900 truncate">
                    {/* A revoked member leaves the thread readable but nameless. */}
                    {thread.other?.name || "Former member"}
                  </span>
                  {thread.unread > 0 && (
                    <span className="ml-auto min-w-[20px] h-5 px-1.5 rounded-full bg-status-critical text-white text-[11px] font-semibold flex items-center justify-center">
                      {thread.unread > 9 ? "9+" : thread.unread}
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-500 truncate">
                  {thread.last_message_preview || "No messages yet"}
                </p>
              </div>
            </button>
          </li>
        ))}
      </ul>

      {contacts.length > 0 && (
        <div className="border-t border-slate-200 mt-2 pt-2">
          <div className="px-4 pb-2 text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-400">
            Start a conversation
          </div>
          <ul>
            {contacts.map((contact) => (
              <li key={contact.id}>
                <button
                  data-testid={`contact-${contact.id}`}
                  onClick={() => onStart(contact.id)}
                  className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-slate-50 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-600"
                >
                  <span className="text-sm text-slate-700 truncate">{contact.name}</span>
                  <span
                    className={`ml-auto text-[10px] px-1.5 py-0.5 rounded-full ${roleBadgeStyle(contact.role)}`}
                  >
                    {contact.role_label || roleLabel(contact.role)}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
